module.exports = __webpack_public_path__ + "img/icone-gas.f6e4fbfd.svg";